import clsx from "clsx";
import styles from "./ChartLegend.module.scss";
import { useTranslation } from "next-i18next";

export const ChartLegend = ({
    buyValue,
    holdValue,
    sellValue,
    colorTheme,
}: {
    buyValue: number;
    holdValue: number;
    sellValue: number;
    colorTheme?: "dark" | "light";
}) => {
    const { t } = useTranslation("common");

    return (
        <div className={styles.legend}>
            <div className={styles.item}>
                <div className={clsx(styles.block, styles.buy)}></div>
                <div className={styles.title}>
                    <span className={styles.operation}>{t("buy")}</span>
                    <span
                        className={clsx(styles.value, {
                            [styles.light]: colorTheme === "light",
                            [styles.dark]: colorTheme === "dark",
                        })}>
                        {buyValue}
                    </span>
                </div>
            </div>
            <div className={styles.item}>
                <div className={clsx(styles.block, styles.hold)}></div>
                <div className={styles.title}>
                    <span className={styles.operation}>{t("hold")}</span>
                    <span
                        className={clsx(styles.value, {
                            [styles.light]: colorTheme === "light",
                            [styles.dark]: colorTheme === "dark",
                        })}>
                        {holdValue}
                    </span>
                </div>
            </div>
            <div className={styles.item}>
                <div className={clsx(styles.block, styles.sell)}></div>
                <div className={styles.title}>
                    <span className={styles.operation}>{t("sell")}</span>
                    <span
                        className={clsx(styles.value, {
                            [styles.light]: colorTheme === "light",
                            [styles.dark]: colorTheme === "dark",
                        })}>
                        {sellValue}
                    </span>
                </div>
            </div>
        </div>
    );
};
